import { handleActions } from 'redux-actions'
import {
  PROCESS_EDITED_DATA_INIT,
  PROCESS_EDITED_DATA_DONE,
  PROCESS_EDITED_DATA_FAIL,
  UPDATE_EDITED_DATA_STATE,
  SHOW_URL_EDIT_MODAL,
  SHOW_EDIT_MODAL,
  SHOW_LOG_MODAL,
  CHANGE_EDIT_PROFILE_PIC_INITIAL_STATE,
  EXPAND_LEFT_NAV,
  TOGGLE_RIGHT_NAV,
} from '../actions/Edit'
import $ from 'jquery'

const initialState = {
  id: null,
  log_id: 0,
  uploaded_at: null,

  section_name: '',
  sub_section_id: null,
  new_sub_section: false,
  delete_sub_section: false,

  uploading_edited_data: false,
  uploaded_edited_data: false,
  show_url_edit_modal: false,
  show_edit_modal: false,
  show_log_modal: false,
  active_edit_modal_section: '',
  initiaProfilPicEditState: 0,
  isLeftNavExpand: 1,
  isRightNavToggle: 1,
}

export const editData = handleActions(
  {
    [PROCESS_EDITED_DATA_INIT]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.uploading_edited_data = true
      newState.uploaded_edited_data = false
      if (action.payload !== false) {
        newState.section_name = action.payload.section_name
        newState.sub_section_id = action.payload.sub_section_id
        newState.new_sub_section = action.payload.new_sub_section
        newState.delete_sub_section = action.payload.delete_sub_section
      } else {
        newState.section_name = ''
        newState.sub_section_id = null
        newState.new_sub_section = false
        newState.delete_sub_section = false
      }
      return newState
    },

    [PROCESS_EDITED_DATA_DONE]: {
      next(state, action) {
        let newState = $.extend(true, {}, state)
        newState.uploading_edited_data = false
        if (action.payload !== false) {
          newState.id = action.payload.id
          newState.log_id = action.payload.log_id
          newState.uploaded_at = action.payload.uploaded_at
          newState.uploaded_edited_data = true
        }
        return newState
      },
      throw(state, action) {
        let newState = $.extend(true, {}, state)
        newState.uploading_edited_data = false
        return newState
      },
    },

    [PROCESS_EDITED_DATA_FAIL]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.uploading_edited_data = false
      return newState
    },

    [UPDATE_EDITED_DATA_STATE]: (state, action) => {
      let newState = $.extend(true, {}, state)
      let updateKeys = action.payload.updateKeys
      let data = action.payload.data
      for (let i in updateKeys) {
        if (updateKeys[i].length == 1) {
          newState[updateKeys[i][0]] = data[updateKeys[i][0]]
        } else if (updateKeys[i].length == 2) {
          newState[updateKeys[i][0]][updateKeys[i][1]] =
            data[updateKeys[i][0]][updateKeys[i][1]]
        } else if (updateKeys[i].length == 3) {
          newState[updateKeys[i][0]][updateKeys[i][1]][updateKeys[i][2]] =
            data[updateKeys[i][0]][updateKeys[i][1]][updateKeys[i][2]]
        }
      }
      return newState
    },

    [SHOW_URL_EDIT_MODAL]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.show_url_edit_modal = action.payload
      return newState
    },
    [SHOW_EDIT_MODAL]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.show_edit_modal = action.payload.isShowModal
      newState.active_edit_modal_section = action.payload.activeEditSection
      return newState
    },
    [CHANGE_EDIT_PROFILE_PIC_INITIAL_STATE]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.initiaProfilPicEditState = action.payload
      return newState
    },
    [EXPAND_LEFT_NAV]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.isLeftNavExpand = action.payload
      return newState
    },
    [TOGGLE_RIGHT_NAV]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.isRightNavToggle = action.payload
      return newState
    },
    [SHOW_LOG_MODAL]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.show_log_modal = action.payload.isShowLogModal
      return newState
    },
  },
  initialState
)
